define((require) => {
    "use strict";

    const _               = require("underscore");
    const GroupModel      = require("shared/ui/groups/GroupModel");
    const Breakpoint      = require("shared/ui/breakpoint/Breakpoint");
    const ExperienceModel = require("shared/ui/experience/ExperienceModel");

    /**
     * Represents a group of <tt>Breakpoint</tt>'s - referencing <tt>ExperienceModel</tt>'s.
     *
     * @class BreakpointGroup
     */

    const BreakpointGroup = GroupModel.extend("BreakpointGroup", {

        /**
         * @inheritDoc
         */
        types: [Breakpoint, ExperienceModel],

        getAssetByThreshold(threshold) {
            const found = this.get("entries").find((entry) => {
                const value = entry.get("value");
                return value && value.get("threshold") === threshold;
            });

            return found && found.get("asset");
        },
        /**
         * Compare two sets of breakpoint thresholds. They are considered equal if the two sets have same number of
         * thresholds and each threshold has a match.
         *
         * Note: if there is no breakpoint in the group, it is considered equal
         *
         * @param {Breakpoint[]} otherLowerBounds   An array of breakpoints
         * @returns {Boolean} True if they are equal, false otherwise.
         */
        compareThresholds(otherLowerBounds) {
            const myLowerBounds = this.getValues();
            const sameNumOfBreakpoints = myLowerBounds.length === otherLowerBounds.length;

            if (!this.hasBreakpoints()) {
                return true;
            }

            if (!sameNumOfBreakpoints) {
                return false;
            }

            return _.every(otherLowerBounds, (breakpoint) => (
                _.find(myLowerBounds, (bp) => breakpoint.get("threshold") === bp.get("threshold"))
            ));
        },

        hasBreakpoints() {
            return this.getValues().length;
        }
    }, {

        /**
         * @inheritDoc
         */
        type: "BreakpointGroup"

    });

    return BreakpointGroup;
});



// WEBPACK FOOTER //
// ./src/shared/ui/breakpoint/BreakpointGroup.js